import { Sparkles, Loader2, Lock, AlertTriangle } from 'lucide-react';

const fmtDate = (s) => {
    if (!s) return '';
    const d = new Date(String(s).replace(' ', 'T'));
    return isNaN(d) ? '' : d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' });
};

/**
 * Bandeau de la thématique d'essai (migration 181), en tête de la vue de la thématique.
 * trial = { state: 'pending'|'active'|'expired', days_left, ends_at, nb_questions } (scopes/detail.php)
 * activeJob = job suivi par le store (génération du sujet d'essai en cours).
 */
export default function TrialBanner({ trial, activeJob = null, onUnlock, onOpenGestion }) {
    if (!trial) return null;
    const unlock = onUnlock && (
        <button type="button" className="btn btn-primary btn-sm trial-banner__cta" onClick={onUnlock}>
            <Lock size={13} /> Débloquer la thématique
        </button>
    );

    if (trial.state === 'pending') {
        const running = activeJob && (activeJob.status === 'QUEUED' || activeJob.status === 'PROCESSING');
        const failed = activeJob && activeJob.status === 'FAILED';
        return (
            <div className="trial-banner trial-banner--pending">
                {running ? <Loader2 size={16} className="spin" /> : failed ? <AlertTriangle size={16} /> : <Sparkles size={16} />}
                <div className="trial-banner__text">
                    {running ? (
                        <><strong>Génération de votre sujet en cours… {activeJob.progress || 0}%</strong>
                            <span>Cela prend quelques minutes ; vous pouvez quitter la page, le sujet apparaîtra ici. Les {trial.days || 7} jours d’essai démarrent à la fin de la génération.</span></>
                    ) : failed ? (
                        <><strong>La génération n’a pas abouti.</strong>
                            <span>Votre essai n’est pas consommé : relancez avec le même document ou une autre idée.</span></>
                    ) : (
                        <><strong>Essai gratuit : votre sujet est en préparation.</strong>
                            <span>S’il n’apparaît pas d’ici quelques minutes, relancez la génération.</span></>
                    )}
                </div>
                {!running && onOpenGestion && (
                    <button type="button" className="btn btn-secondary btn-sm" onClick={onOpenGestion}>Relancer</button>
                )}
            </div>
        );
    }

    if (trial.state === 'active') {
        const n = trial.days_left || 1;
        return (
            <div className="trial-banner trial-banner--active">
                <Sparkles size={16} />
                <div className="trial-banner__text">
                    <strong>Essai gratuit : encore {n} jour{n > 1 ? 's' : ''}</strong>
                    <span>{trial.can_generate
                        ? `Il vous reste à créer votre propre sujet de ${trial.nb_questions || 20} questions, à partir de votre document ou d’une idée.`
                        : `Votre sujet est ouvert à tous les modes d’entraînement. Avec l’abonnement : d’autres sujets, l’enrichissement, les catégories et le partage.`}</span>
                </div>
                {trial.can_generate && onOpenGestion && (
                    <button type="button" className="btn btn-secondary btn-sm" onClick={onOpenGestion}>Créer mon sujet</button>
                )}
                {unlock}
            </div>
        );
    }

    return (
        <div className="trial-banner trial-banner--expired">
            <Lock size={16} />
            <div className="trial-banner__text">
                <strong>Essai terminé{trial.ends_at ? ` le ${fmtDate(trial.ends_at)}` : ''}</strong>
                <span>Vos résultats et votre progression restent visibles. Débloquez la thématique pour rejouer votre sujet et en créer d’autres.</span>
            </div>
            {unlock}
        </div>
    );
}
